import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import List from './List.vue';
import Edit from './Edit.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    List: List,
    Edit: Edit
  },
  data: function data() {
    return {
      isShowList: true,
      isShowEdit: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onAnnouncementCancel', function () {
      _this.setOrderStatu('listShow');
    });
  },
  methods: _objectSpread({}, mapActions('Portal/Announcement', ['setOrderStatu'])),
  watch: {
    AnnouncementState: {
      handler: function handler(nawValue) {
        console.log('单据操作状态 DeliveryCodeOrderState==>', nawValue);

        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowList = true;
          this.isShowEdit = false;
          this.$refs.List.getLoadData();
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'editOrder') {
          this.isShowList = false;
          this.isShowEdit = true;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['AnnouncementState']))
};